import * as types from "../../store/mutation-types";
import { register } from "../../store/api/api";

const state = {
  driver_id: null
};
const getters = {};
const actions = {
  async driverSignUp({ commit }, data) {
    return new Promise((resolve, reject) => {
      register(data)
        .then(response => {
          if (response && response.data) {
            commit(types.SET_DRIVER_ID, response.data.id);
            resolve(response);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  }
};
const mutations = {
  [types.SET_DRIVER_ID](state, data) {
    state.driver_id = data;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
